const OnOrOff = [
  { id: "1", name: "开启" },
  { id: "0", name: "关闭" },
];
const RechargeDeduction = [
  { id: "1", name: "充值" },
  { id: "2", name: "扣款" },
];
const Operator = [
  { id: "1", name: "鑫源" },
  { id: "2", name: "lenovo" },
  { id: "3", name: "蓝猫" },
  { id: "4", name: "三五字节云" },
];
const IccidStatus = [
  { id: "1", name: "蓝猫" },
  { id: "2", name: "话机世界" },
  { id: "3", name: "懂的" },
  { id: "4", name: "263" },
];
const ShutdownReason = [
  { id: "1", name: "未用系统拨打" },
  { id: "2", name: "跳出系统拨打" },
  { id: "3", name: "辱骂" },
  { id: "4", name: "无录音" },
  { id: "5", name: "录音与报备话术不符" },
  { id: "6", name: "其他" },
  { id: "7", name: "同批次" },
];
const AutomaticRestart = [
  { id: "0", name: "不自动复机" },
  { id: "8", name: "自动复机(8小时)" },
  { id: "24", name: "自动复机(24小时)" },
  { id: "48", name: "自动复机(48小时)" },
  { id: "72", name: "自动复机(72小时)" },
];
const RiskStatement = [
  { id: "0", name: "异常" },
  { id: "1", name: "正常" },
  { id: "2", name: "低风险" },
  { id: "3", name: "高风险" },
];
export default {
  OnOrOff,
  RechargeDeduction,
  IccidStatus,
  ShutdownReason,
  AutomaticRestart,
  Operator,
  RiskStatement,
};
